import { FC, useState, useEffect } from 'react'
import Image from 'next/image'
import clsx from 'clsx'

import { useRouter } from 'next/router'
import { useForm, useFormState } from 'react-hook-form'

import Auth from 'store/auth'
import Sidebar from '../../sidebar/sidebar'
import ControllerBaseInput from 'components/form-parts/controller-hook-forms/controller-base-input/controller-base-input'
import ControllerTexrArea from 'components/form-parts/form-textarea-react/form-textarea-react'
import Button from 'components/parts/button/button'
import NMOInstrBtn from 'components/parts/nmo-instr-btn/nmo-instr-btn'

import { postAxiosSingle } from 'pages/api/axios'
import { imgPath } from './data'
import { FieldsNameVoc, emailValidation, textAreaValidation } from 'constants/auth/profile-data'
import { BASE_URL } from 'constants/url'
import { ANIMATION_POPUP_TIME } from 'containers/animation-wrap/data'
import { enableDocumentScroll, disableDocumentScroll } from 'utils/handlerDocumentScroll'

import styles from './write-us.module.scss'
interface IWriteUs {
  toggleFeedback: boolean
  setToggleFeedback: (arg: boolean) => void
  noScroll?: boolean
}

const WriteUs: FC<IWriteUs> = ({ toggleFeedback, setToggleFeedback, noScroll }: IWriteUs) => {
  const [isSent, isAlreadySent] = useState(false)

  const { asPath } = useRouter()
  const { isAuthorized, userProfile } = Auth.useAuth()
  const { email } = userProfile

  const onSubmit = async (values: any) => {
    try {
      const data = await postAxiosSingle(
        `${BASE_URL.FEEDBACK}/question`,
        {},
        { email: values.email, text: values.textarea, path: asPath }
      )
      if (data.status === 200 || data.status === 201) {
        isAlreadySent(true)
      }
    } catch (err) {
      setError('textarea', { type: 'custom', message: 'Не удается отправить, попробуйте позже' })
      console.warn(err)
    }
  }
  const { handleSubmit, control, setValue, clearErrors, setError } = useForm({
    mode: 'onBlur',
  })
  const { errors } = useFormState({ control })

  const handleFeedBack = () => {
    setToggleFeedback(false)

    setTimeout(() => {
      isAlreadySent(false)
      setValue('textarea', '')
      clearErrors()
    }, ANIMATION_POPUP_TIME)
  }

  useEffect(() => {
    if (isAuthorized) {
      setValue(FieldsNameVoc.email, email)
    }
  }, [email, isAuthorized])

  useEffect(() => {
    if (noScroll) {
      return
    }
    toggleFeedback ? disableDocumentScroll() : enableDocumentScroll()
  }, [toggleFeedback])

  return (
    <>
      <Sidebar isActive={toggleFeedback} iconData modificator={styles.sidebar}>
        <div
          className={clsx(styles.writeUsOverlay, {
            [styles.disable]: !toggleFeedback,
          })}
          onClick={handleFeedBack}
        ></div>
        {isSent ? (
          <div>
            <div className={styles.final_message}>
              <h1>Напишите нам</h1>
              <p>Ваше сообщение отправлено!</p>
              <p>Ответим в ближайшее время по почте 😊</p>
              <div className={styles.final_btn} onClick={handleFeedBack}>
                <Button>Ок, спасибо</Button>
              </div>
            </div>
          </div>
        ) : (
          <form className={styles.form_writeus} onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.title}>
              <h1>Напишите нам</h1>
              <span onClick={handleFeedBack} className={styles.close}>
                <Image src={imgPath.close} width="16" height="16" alt="Закрыть" />
              </span>
            </div>
            {!isAuthorized && (
              <div className={styles.email_input}>
                <ControllerBaseInput
                  control={control}
                  name={FieldsNameVoc.email}
                  dynamicName
                  errors={errors}
                  noErrorOnTouch={clearErrors}
                  rules={emailValidation}
                />
              </div>
            )}
            <div className={styles.textarea_input}>
              <ControllerTexrArea
                control={control}
                errors={errors}
                name="textarea"
                noErrorOnTouch={clearErrors}
                rules={textAreaValidation}
              />
            </div>
            <div className={styles.btn_wrapper}>
              <Button
                type="submit"
                modificator={Object.keys(errors).length === 0 ? '' : styles.disableBtn}
              >
                Отправить
              </Button>
              <NMOInstrBtn />
            </div>
          </form>
        )}
      </Sidebar>
    </>
  )
}

export default WriteUs
